import { ProjectViewModel } from "../../ViewModel/ProjectViewModel";

export const getPdsrById = (pdsrId: number, project: ProjectViewModel) => {
  return project.PdsrsOnThisProject?.find((pdsr) => pdsr.PdsrId === pdsrId);
};
